import React, { useState, useEffect, useContext } from 'react';
import Container from 'react-bootstrap/Container';
import { Jumbotron } from './migration';
import Row from 'react-bootstrap/Row';
import { Col, Badge } from 'react-bootstrap';
import Card from 'react-bootstrap/Card';
import moment from 'moment';
import { ThemeContext } from '../../App';
import axios from 'axios';
import { motion } from 'framer-motion';

const Blogs = () => {
  const { theme } = useContext(ThemeContext);
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  const getPostData = () => {
    axios
      .get('https://api.rss2json.com/v1/api.json?rss_url=https://medium.com/feed/@rauniyarankit')
      .then((res) => {
        setArticles(res.data.items);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching blog posts:', error);
        setLoading(false);
      });
  };

  useEffect(() => {
    getPostData();
  }, []);

  return (
    <Jumbotron fluid id="blogs" className="blogs m-0">
      <Container>
        <motion.h2
          className="display-4 pb-5 text-center"
          initial={{ opacity: 0, y: -24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.45 }}
          style={{ fontWeight: 700, color: 'var(--text-primary)' }}
        >
          Blogs
        </motion.h2>
        <Row>
          {loading ? (
            <Col className="text-center">
              <p style={{ color: 'var(--text-secondary)' }}>Loading blogs...</p>
            </Col>
          ) : articles.length === 0 ? (
            <Col className="text-center">
              <p style={{ color: 'var(--text-secondary)' }}>No blog posts available.</p>
            </Col>
          ) : (
            articles.map((article, index) => (
              <Col md={6} key={article.id || index}>
                <motion.a
                  href={article.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-50px" }}
                  transition={{ delay: index * 0.06, duration: 0.45 }}
                  whileHover={{ scale: 1.01 }}
                >
                  <Card className="card blogcard shadow-lg p-4 mb-5 rounded">
                    <Card.Body>
                      <Card.Title 
                        style={{ 
                          color: 'var(--text-primary)',
                          fontWeight: 700,
                          marginBottom: '1rem',
                          fontSize: '1.5rem'
                        }}
                      >
                        {article.title}
                      </Card.Title>
                      <div style={{ marginBottom: '1rem' }}>
                        <div style={{ 
                          display: 'flex', 
                          flexWrap: 'wrap', 
                          gap: '0.5rem',
                          marginBottom: '0.75rem'
                        }}>
                          {article.categories.map((category) => (
                            <Badge
                              key={category}
                              style={{
                                padding: '0.5rem 1rem',
                                borderRadius: '20px',
                                fontWeight: 600,
                                backgroundColor: theme === 'light' ? '#212529' : '#ffffff',
                                color: theme === 'light' ? '#ffffff' : '#212529',
                                fontSize: '0.85rem'
                              }}
                            >
                              {category}
                            </Badge>
                          ))}
                        </div>
                        <div style={{ 
                          color: 'var(--text-secondary)',
                          fontSize: '0.95rem',
                          fontWeight: 500
                        }}>
                          Published: {moment(article.pubDate).format('D MMM, YYYY')}
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </motion.a>
              </Col>
            ))
          )}
        </Row>
      </Container>
    </Jumbotron>
  );
};

export default Blogs;
